export default __webpack_public_path__ + "static/media/therapy-kit.7b57f407.svg";